import React from "react";
import MUIDialogActions from "@mui/material/DialogActions";
import { getClassName } from "@sscs/utils";
import styles from "./dialog.module.scss";
/** Secondary text flush left in the footer row, e.g. "Step 3 of 5". */
const Meta = ({ className, children }) => (React.createElement("div", { className: getClassName(styles.meta, className) }, children));
/** The button cluster. Call sites put the primary action rightmost. */
const Actions = ({ className, children }) => (React.createElement("div", { className: getClassName(styles.actions, className) }, children));
/** The dialog's bottom band. Padding and top hairline live in the theme (Theme/overrides/dialog.ts). */
const Footer = ({ className, children }) => (React.createElement(MUIDialogActions, { className: className }, children));
Footer.Meta = Meta;
Footer.Actions = Actions;
export { Meta, Actions };
export default Footer;
//# sourceMappingURL=DialogFooter.js.map